import React, { useState, useRef, useEffect } from "react";

import { useFormCtx } from "./FormContext";
import useScreenType from "./hooks/useScreenType";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";
import ScaleSpinnerProgressSection from "./components/ScaleSpinnerProgressSection";

function PageHwSwInfo() {
  const screenType = useScreenType();
  const [data, setData] = useState();
  const { getTerminalHwInfo, isTaskRunning, terminalSettingsState } = useFormCtx();
  const textareaRef = useRef(null);

  useEffect(() => {
    async function scopedLoadData() {
      await readData();
    }

    scopedLoadData();
  }, []);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [data]);

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "key":
          css = "min-w-[108px] text-secondary text-sm";
          break;
        case "val":
          css = "ml-2 text-sm";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-xl text-accent-dark mt-2";
          break;
        case "footer":
          css = "h-[65px]";
          break;
        case "parent":
          css = "h-[416px]";
          break;
        case "btn":
          css = "h-14 text-sm";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "key":
          css = "min-w-[190px] text-secondary text-xl";
          break;
        case "val":
          css = "ml-4 text-xl";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-2xl text-accent-dark mt-4";
          break;
        case "footer":
          css = "h-[100px]";
          break;
        case "parent":
          css = "h-[624px]";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "key":
          css = "min-w-[190px] text-secondary text-xl";
          break;
        case "val":
          css = "ml-4 text-xl";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-2xl text-accent-dark mt-4";
          break;
        case "footer":
          css = "h-[100px]";
          break;
        case "parent":
          css = "h-[704px]";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    }

    return css;
  }

  async function readData() {
    const result = await getTerminalHwInfo();
    setData(result?.data);
  }

  /*
data = {
            "model": model,
            "temperature": temp,
            "cpu": cpu,
            "ram": ram,
            "disk": disk,
            "camera": camera,
            "connection": net_type,
            "ip": ip,
            "ip_method": ip_method,
            "mask": mask,
            "gate": gate,
            "dns": dns,
            "uid": uid,
            "script": __version__,
            "api_url": apiUrl,
            "push_service": push_service,
            "terminal_service": terminal_service,
            "chromium_url": chromium_url            
        }
*/

  const camera = data?.camera?.slice(0, data?.camera?.indexOf("]") + 1);
  const temp = data?.temperature ? data?.temperature / 1000 : 0;
  //console.log(data);

  return (
    <>
      <Navbar useCustomTitle={true} customTitle={"Informace o terminálu - HW - SW"} />
      {(isTaskRunning || !data) && <ScaleSpinnerProgressSection />}
      {!isTaskRunning && data && (
        <div className="h-[416px] scRPIV2:h-[624px] scWaveShare:h-[704px] tvFullHD:h-[940px] tv4K:h-[1804px] flex flex-col overflow-hidden">
          <div className="flex-1 overflow-y-auto grid grid-cols-2 mb-2">
            {/* 1. radek  */}
            <div className="mx-4 scRPIV2:mx-4 scWaveShare:mx-4 tvFullHD:mx-8 tv4K:mx-12">
              <h1 className="text-xl text-accent-dark mt-2 scRPIV2:text-xl scRPIV2:mt-2 scWaveShare:text-2xl scWaveShare:mt-4 tvFullHD:mt-8 tvFullHD:text-5xl tv4K:mt-12 tv4K:text-8xl">
                HW informace:
              </h1>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Model:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.model}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Teplota:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {temp}°C{" "}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  CPU vytížení:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.cpu}%
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  RAM zaplnění:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.ram}%
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  DISK zaplnění:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.disk}%
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Kamera:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {camera}
                </div>
              </div>
            </div>

            <div className="mx-4 scRPIV2:mx-4 scWaveShare:mx-4 tvFullHD:mx-8 tv4K:mx-12">
              <h1 className="text-xl text-accent-dark mt-2 scRPIV2:text-xl scRPIV2:mt-2 scWaveShare:text-2xl scWaveShare:mt-4 tvFullHD:mt-8 tvFullHD:text-5xl tv4K:mt-12 tv4K:text-8xl">
                Síťové informace:
              </h1>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Připojení:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.connection}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  IP:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.ip}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Přidělení IP:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.ip_method}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Maska:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.mask}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Brána:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.gate}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  DNS:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.dns}
                </div>
              </div>
            </div>

            {/* 2. radek  */}
            <div className="mx-4 scRPIV2:mx-4 scWaveShare:mx-4 tvFullHD:mx-8 tv4K:mx-12">
              <h1 className="text-xl text-accent-dark mt-2 scRPIV2:text-xl scRPIV2:mt-2 scWaveShare:text-2xl scWaveShare:mt-4 tvFullHD:mt-8 tvFullHD:text-5xl tv4K:mt-12 tv4K:text-8xl">
                Terminál + TERMINAL_APP:
              </h1>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Verze scriptu:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.script}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Terminál:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.uid}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Mobile UID:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {terminalSettingsState.mobileUID}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Klíč:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {terminalSettingsState.keyNumber}
                </div>
              </div>

              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  API URL:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.api_url}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  PUSHY Service:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.push_service}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Terminal Service:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.terminal_service}
                </div>
              </div>
            </div>
            <div className="mx-4 scRPIV2:mx-4 scWaveShare:mx-2 tvFullHD:mx-8 tv4K:mx-12">
              <h1 className="text-xl text-accent-dark mt-2 scRPIV2:text-xl scRPIV2:mt-2 scWaveShare:text-2xl scWaveShare:mt-4 tvFullHD:mt-8 tvFullHD:text-5xl tv4K:mt-12 tv4K:text-8xl">
                Web Aplikace:
              </h1>
              <div className="text-primary flex tvFullHD:mt-1 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Verze scriptu:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {Const.APP_VERSION}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Enviroment:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {Const.ENV}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Web App URL:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {Const.APP_URL}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  Chromium URL:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {data?.chromium_url}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  API URL:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {Const.API_URL}
                </div>
              </div>
              <div className="text-primary flex tvFullHD:mt-2 tv4K:mt-6">
                <div className="text-secondary min-w-[108px] text-sm scRPIV2:text-xl scRPIV2:min-w-[190px] scWaveShare:text-xl scWaveShare:min-w-[190px] tvFullHD:text-2xl tvFullHD:min-w-[200px] tv4K:text-6xl tv4K:min-w-[500px]">
                  TERMINAL_APP:
                </div>
                <div className="ml-2 text-sm scRPIV2:ml-4 scRPIV2:text-xl scWaveShare:ml-4 scWaveShare:text-xl tvFullHD:ml-4 tvFullHD:text-2xl tv4K:text-6xl tv4K:ml-8">
                  {Const.TERMINAL_APP_URL}
                </div>
              </div>
            </div>
          </div>
          <div className="h-[65px] scRPIV2:h-[100px] scWaveShare:h-[100px] tvFullHD:h-[100px] tv4K:h-[200px] bg-disabled-darka flex items-center place-content-center justify-center">
            <Button
              type="primary"
              title="Načíst hodnoty"
              showIcon={false}
              onClick={() => readData()}
              className="className=h-14 -mt-1 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-30 tvFullHD:text-2xl tv4K:h-44 tv4K:text-5xl tv4K:mt-4"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default PageHwSwInfo;
